<script setup>
import { Icon } from '@iconify/vue';
import DashboardWidgetCard from './DashboardWidgetCard.vue';
import DoughnutChart from '@/Components/Charts/DoughnutChart.vue';

defineProps({
    chartData: {
        type: Object,
        default: null,
    },
    loading: {
        type: Boolean,
        default: false,
    },
    error: {
        type: String,
        default: null,
    },
});

const emit = defineEmits(['reload']);
</script>

<template>
    <DashboardWidgetCard
        title="Almacenamiento en Disco"
        subtitle="Uso de espacio por documentos y archivos"
        icon="tabler:hard-drive"
        iconColor="amber"
        :loading="loading"
        :error="error"
        :empty="!chartData"
        emptyMessage="No hay datos de disco disponibles."
        @reload="emit('reload')"
    >
        <div v-if="chartData" class="flex flex-col items-center justify-center p-2">
            <div class="w-full max-w-xs h-72">
                <DoughnutChart :data="chartData" title="Uso de Disco" class="h-full w-full" />
            </div>
            <p class="text-xs text-gray-400 text-center mt-2">
                Monitoreo automático del almacenamiento del servidor.
            </p>
        </div>
    </DashboardWidgetCard>
</template>
